import { render, staticRenderFns } from "./member-configure-add-modal.vue?vue&type=template&id=c8f9a80c&scoped=true&"
import script from "./member-configure-add-modal.vue?vue&type=script&lang=ts&"
export * from "./member-configure-add-modal.vue?vue&type=script&lang=ts&"
import style0 from "./member-configure-add-modal.vue?vue&type=style&index=0&id=c8f9a80c&prod&lang=less&scoped=true&"
import style1 from "./member-configure-add-modal.vue?vue&type=style&index=1&id=c8f9a80c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f9a80c",
  null
  
)

export default component.exports